"use strict";

exports.__esModule = true;
exports.DataAccessorContext = void 0;
var _Utils = require("../../../Utils");
var _DataAccessController = require("./DataAccessController");
var DataAccessorContext = exports.DataAccessorContext = (0, _Utils.createEnhancedContext)({
  propName: "dataAccessor",
  defaultController: _DataAccessController.DataAccessController
});